import { Link} from 'react-router-dom';
export default function Hero() {

    return (
        <section className="hero">
            <div className="container">
                <h1>YOUR RETAIL GROWTH PARTNER IN INDIA</h1>
                <p>We leverage data to uncover insights that impact your business, and we tell you how to act on those insights.</p>
                <p>We don’t just analyze, we activate!</p>
                <Link to="/about" className="btn">Know More</Link>
            </div>
        </section>
    )
}
